import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { notification } from 'antd'
import { IEditBadgePayload } from '@app-store/slices/badges/editBadge'

interface TaskAction extends Action {
    payload: IEditBadgePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.badges.edit

function* editBadgeSagaTask({ payload }) {
    try {
        const response = yield axios.patch(`/event/settings/badge/${payload.id}`, payload.data)
        if (response.success) {
            notification.success({
                message: 'Badge updated successfully.'
            })
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editBadgeSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editBadgeSagaTask)
}

export default editBadgeSaga
